import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "selector__subtitle"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Magnify = _resolveComponent("Magnify")
  const _component_NcTextField = _resolveComponent("NcTextField")
  const _component_ConversationsSearchListVirtual = _resolveComponent("ConversationsSearchListVirtual")
  const _component_MessageOutline = _resolveComponent("MessageOutline")
  const _component_NcEmptyContent = _resolveComponent("NcEmptyContent")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NcDialog = _resolveComponent("NcDialog")

  return (_openBlock(), _createBlock(_component_NcDialog, {
    name: $props.dialogTitle,
    "close-on-click-outside": "",
    "onUpdate:open": $options.close
  }, {
    default: _withCtx(() => [
      ($props.dialogSubtitle)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString($props.dialogSubtitle), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_NcTextField, {
        modelValue: $data.searchText,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.searchText) = $event)),
        "trailing-button-icon": "close",
        class: "selector__search",
        label: $options.t('spreed', 'Search conversations or users'),
        "show-trailing-button": $data.searchText !== '',
        onTrailingButtonClick: $options.clearText
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_Magnify, { size: 16 })
        ]),
        _: 1
      }, 8, ["modelValue", "label", "show-trailing-button", "onTrailingButtonClick"]),
      ($data.loading || $options.availableRooms.length > 0)
        ? (_openBlock(), _createBlock(_component_ConversationsSearchListVirtual, {
            key: 1,
            conversations: $options.availableRooms,
            loading: $data.loading,
            class: "selector__list",
            onSelect: $options.onSelect
          }, null, 8, ["conversations", "loading", "onSelect"]))
        : (_openBlock(), _createBlock(_component_NcEmptyContent, {
            key: 2,
            name: $options.noMatchFoundTitle,
            description: $options.noMatchFoundSubtitle
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_MessageOutline, { size: 64 })
            ]),
            _: 1
          }, 8, ["name", "description"]))
    ]),
    actions: _withCtx(() => [
      (!$data.loading && $options.availableRooms.length > 0)
        ? (_openBlock(), _createBlock(_component_NcButton, {
            key: 0,
            class: "selector__action",
            variant: "primary",
            disabled: !$setup.selectedRoom,
            onClick: $options.onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($options.t('spreed', 'Select conversation')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["name", "onUpdate:open"]))
}